import styled from '@emotion/styled';
import { GlobalArea } from '@libs/templates/global-area';
import { BackDropSpinnerProvider } from '@ps-smart-cp/ppfw-client';
import { Outlet } from 'react-router';
import { hasSandboxToken } from '../../../../libs/templates/src/global-area/services';
import {
  BooksProvider,
  CompanyProvider,
  CustomFieldSettingsProvider,
  MstSettingsProvider,
  OperationControlProvider,
  ProcessingMonthProvider,
} from '../context';
import { ProcessingMonthLabel } from './ProcessingMonthLabel';
import { SandboxLabel } from './SandboxLabel';

const LabelContainer = styled.div`
  display: flex;
  gap: 5px;
`;

function ContainerWithContext() {
  return (
    <CompanyProvider>
      <ProcessingMonthProvider>
        <BooksProvider>
          <MstSettingsProvider>
            <CustomFieldSettingsProvider>
              <OperationControlProvider>
                <BackDropSpinnerProvider>
                  <GlobalArea homePath="/fa/main-menu">
                    <LabelContainer>
                      {hasSandboxToken() && <SandboxLabel />}
                      <ProcessingMonthLabel />
                    </LabelContainer>
                  </GlobalArea>
                  <Outlet />
                </BackDropSpinnerProvider>
              </OperationControlProvider>
            </CustomFieldSettingsProvider>
          </MstSettingsProvider>
        </BooksProvider>
      </ProcessingMonthProvider>
    </CompanyProvider>
  );
}

export { ContainerWithContext };
